import React from 'react'
import { ApolloProvider } from '@apollo/client'
import { ThemeContextProvider } from '@/contexts/ThemeContext'
import { Analytics } from '@/layout/Analytics'
import { ErrorBoundary, ErrorFallback } from '@/layout/ErrorBoundary'
import { DefaultSeo } from '@/layout/Seo'
import { ToastProvider } from '@/molecules/Toast/ToastProvider'
import { getWebClient } from '@/services/ApolloClient'
import { useLocale } from '@/utils/LocaleUtil'

interface ContentOnlyLayoutProps {
  children: React.ReactNode
  isDarkMode?: boolean
}

export const ContentOnlyLayout: React.FC<ContentOnlyLayoutProps> = ({ children, isDarkMode }) => {
  const { locale } = useLocale()
  const client = getWebClient({ locale })

  return (
    <ErrorBoundary FallbackComponent={ErrorFallback}>
      <DefaultSeo />
      <Analytics>
        <ApolloProvider client={client}>
          <ErrorBoundary FallbackComponent={ErrorFallback}>
            <ThemeContextProvider isDarkMode={!!isDarkMode}>
              <ToastProvider>{children}</ToastProvider>
            </ThemeContextProvider>
          </ErrorBoundary>
        </ApolloProvider>
      </Analytics>
    </ErrorBoundary>
  )
}
